<template>
  <div>
    <v-stepper-step :complete="step > 2" step="3">
      Promotion Requested
    </v-stepper-step>
    <v-stepper-content step="3">
      <p>Your promotion request has been received.</p>
      <p>
        <strong>
          Confirmation Number:
          <router-link
            :to="{ name: 'promotion_view', params: { promo_id: promoRequestId } }">
            #{{ promoRequestId }}
          </router-link>
        </strong>
      </p>
      <p>You may view and monitor your request or return to the Dashboard. Find your promotion history at
        <router-link
          :to="{ name: 'promotions_list', params: { promo_id: promoRequestId } }">
          <strong>My Promotions</strong>
        </router-link>.
      </p>
      <v-card-actions>
        <gg-btn color="primary" tile elevation="0"  :to="{ name: 'promotion_view', params: { promo_id: promoRequestId } }">
          View Request
        </gg-btn>
        <gg-btn @click="redirectToDashboard" tile elevation="0"  color="gray">Return to Dashboard</gg-btn>
      </v-card-actions>
    </v-stepper-content>
  </div>
</template>

<script>
export default {
  name: 'PromoStepThree',
  props: {
    step: {
      type: Number,
      required: true,
    },
    promoRequestId: {
      type: [Number, String],
      required: true,
    },
  },
  methods: {
    async redirectToDashboard () {
      await this.$router.push({
        name: 'dashboard'
      })
    }
  }
}
</script>
